<template>
    <div
        class="modal fade text-left"
        :id="id"
    >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel1">
                        {{ localizationStore.translate('document.preview') }}
                    </h4>
                    <button @click="closeModal(`#${id}`)" type="button" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <img :src="url" v-if="lodash.includes(type,'image')"/>
                    <embed :src="url" type="application/pdf" width="100%" height="600px" v-else/>
                    <!-- <vue-pdf-embed :source="url" v-else/> -->
                </div>
                <div class="modal-footer">
                    <button @click="closeModal(`#${id}`)" type="button" class="btn btn-primary">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { closeModal, hideModal, openModal } from '../../utilities/_helpers'
    import lodash from 'lodash'
    export default {
        props: {
            id: String,
            type: Boolean,
            url: String
        },
        mounted() {
        },
        setup(props) {
            return {
                closeModal: closeModal,
                localizationStore: useLocalizationStore(),
                lodash: lodash
            }
        },
    }
</script>
